/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />
/// <reference path="../../components/baseClasses/dataMaintenanceContextBase.ts" />

module Meevo.Plugins.MarketPricing {
    'use strict';

    import IMaintenanceFormCustomButton = Meevo.Components.Controls.IMaintenanceFormCustomButton;
    import SecurityParts = Meevo.Components.Common.SecurityParts;
    import ListItem = Meevo.Model.ListItem;
    import ISelectItem = Meevo.Model.ISelectItem;
    import PriceCategoryEnum = Meevo.Model.PriceCategoryEnum;
    import BusinessInfoDataService = Meevo.Components.Common.BusinessInfoDataService;

    export interface IPagerModel extends Meevo.Model.DataMaintenance {
        pages?: any[],
        currentPage?: number,
        count?: number,
        giftCardTypes?: any[],
        services?: any[],
        id?: string,
        warningMessage?: string,
        warning?: string,
    }

    export enum RoundPricesEnum {
        FiftyCent,
        Dollar
    }

    export class SectionParamsMarketPrice<IPagerModel> extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<IPagerModel> {
        dataService: Meevo.Components.Common.ClientMembershipDataService;
        modalService: Meevo.Components.Modal.IModalService;
        discountsService: Meevo.Plugins.Discounts.IDiscountsService;
        showFilteredItems: boolean;
        isPreviewMassUpdate: boolean;
        filterCriteria: any;
        displayPerPage?: number;
        massUpdateCriteria: any;
        serviceCategory: any;
        amount: number;
        revertLocation: boolean;
    }

    export class MarketPricingContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        public customButtonsSet: Array<IMaintenanceFormCustomButton>;
        public isStartApplyFilter: boolean;
        public selectedSection: SectionParamsMarketPrice<IPagerModel>;
        public tomorrow: Date = new Date(new Date(new Date().getTime() + (24 * 60 * 60 * 1000)).setHours(0, 0, 0, 0));
        public displayPerPageList = [
            12,
            24,
            36,
            48
        ]

        public securityKey: string;

        public isPriceManagement: boolean;
        public roundLevelsSelectData: ISelectItem<RoundPricesEnum>[];

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
                    dataService: Meevo.Components.BaseClasses.IDataService,
                    modalService: Meevo.Components.Modal.IModalService,
                    identityService: Meevo.Components.Common.IIdentityService,
                    loggingService: Meevo.Components.Logging.ILoggingService,
                    securityChecker: Meevo.Components.Common.ISecurityService,
                    trackingService: Meevo.Components.Tracking.ITrackingService,
                    protected busyService: Meevo.Components.Busy.IBusyService,
                    protected $rootScope: angular.IRootScopeService,
                    protected $translate: angular.translate.ITranslateService,
                    protected $q: ng.IQService,
                    protected controller: Meevo.Plugins.MarketPricing.MarketPricingController,
                    protected discountsService: Meevo.Plugins.Discounts.IDiscountsService,
                    protected contextService: IContextService,
                    $filter: ng.IFilterService,
                    protected businessInfoService: BusinessInfoDataService) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService, null, false);

            this.isPriceManagement = !this.identityService.inCentralOfficeMode();

            this.baseEndpoint = this.isPriceManagement ? 'PriceManagement' : this.appSettings.API_ENDPOINTS.marketPricing;

            this.sectionTemplatePath = 'app/plugins/marketPricing/sectionViews/';

            this.buildCrudSecurityKeys(this.isPriceManagement ? this.securityKeys.MANAGEMENT_PRICEMANAGEMENT_TAB_PRODUCTS : this.securityKeys.MANAGEMENT_MARKETPRICING_TAB_MAIN);
            this.entityType = 'marketPricing';
            this.securityKey = this.isPriceManagement ? 'PRICEMANAGEMENT' : 'MARKETPRICING';

            // TODO update button
            this.customButtonsSet = [
              {
                    text: 'LABEL_SCHEDULE_LOCATION_TRANSFER',
                    classNames: 'meevo-button-lg meevo-bottom-button',
                    clickHandler: this.scheduleLocationTransfer.bind(this),
                    disableRules: () => false,
                    visibilityRules: () => {
                        return this.selectedSection instanceof LocationsSection
                    },
                    securityRules: this.securityKeys.MANAGEMENT_MARKETPRICING_ACTION_SCHEDULELOCATIONTRANSFER,
                    position: 'right'
                },
                {
                    text: 'LABEL_APPLY_MASS_UPDATE',
                    classNames: 'meevo-button-lg meevo-bottom-button',
                    clickHandler: this.save.bind(this),
                    disableRules: () => false,
                    visibilityRules: () => {
                        return this.selectedSection.isPreviewMassUpdate
                    },
                    securityRules: this.editSecurityKey,
                    position: 'right'
                }
            ];
            this.roundLevelsSelectData =  [
                {
                    value: null,
                    label: $translate.instant('LABEL_NONE')
                },
                {
                    value: RoundPricesEnum.FiftyCent,
                    label: ($filter('meevoCurrency') as any)(0.5)
                },
                {
                    value: RoundPricesEnum.Dollar,
                    label: ($filter('meevoCurrency') as any)(1)
                },
            ];

            this.initializeSections();

        }

        public getSectionSecurityKey(tabName: string, part: SecurityParts = '') {
            return this.securityKeys[`MANAGEMENT_${this.securityKey}_TAB_${tabName}`] + part;
        }

        initializeSections(): void {
            let baseSectionProps: Meevo.Model.ISectionParamsMarketPrice = {
                sectionId: 0,
                displayNameContentKey: '',
                template: '',
                appSettings: this.appSettings,
                isPrimarySection: true,
                handlesOwnCrud: false,
                baseEndpoint: this.baseEndpoint,
                sectionEndpoint: '',
                loggingService: this.loggingService,
                dataService: this.dataService,
                identityService: this.identityService,
                noun: Meevo.Model.NounEnum.MarketPricing,
                $q: this.$q,
                busyService: this.busyService,
                $translate: this.$translate,
                sectionSecurityKey: '',
                usageTrackingLogFn: this.usageTrackingLog.bind(this),
                tabName: 'MAIN',
                businessInfoService: this.businessInfoService,
            }

            this.sections.push(
                new MainSection(
                    _.extend({}, baseSectionProps, {
                        displayNameContentKey: 'SECTION_MAIN',
                        template: 'main.html',
                        tabName: 'MAIN',
                        modalService: this.modalService,
                        sectionSecurityKey: this.getSectionSecurityKey('MAIN', SecurityParts.KEY_PART_READ)
                    })
                ),

                new DiscountsSection(
                    _.extend({}, baseSectionProps, {
                        sectionId: 1,
                        displayNameContentKey: 'LABEL_DISCOUNTS',
                        template: 'discounts.html',
                        tabName: 'DISCOUNTS',
                        discountsService: this.discountsService,
                        sectionSecurityKey: this.getSectionSecurityKey('DISCOUNTS', SecurityParts.KEY_PART_READ)
                    })
                ),

                new PackagesSection(
                    _.extend({}, baseSectionProps, {
                        sectionId: 2,
                        displayNameContentKey: 'LABEL_PACKAGES',
                        template: 'packages.html',
                        tabName: 'PACKAGES',
                        modalService: this.modalService,
                        sectionSecurityKey: this.getSectionSecurityKey('PACKAGES', SecurityParts.KEY_PART_READ)
                    })
                ),

                new GiftCardTypesSection(
                    _.extend({}, baseSectionProps, {
                        sectionId: 3,
                        displayNameContentKey: 'HERO_SUB_GIFT_CARD_TYPES',
                        template: 'giftCardTypes.html',
                        tabName: 'GIFTCARDTYPES',
                        modalService: this.modalService,
                        sectionSecurityKey: this.getSectionSecurityKey('GIFTCARDTYPES', SecurityParts.KEY_PART_READ)
                    })
                ),

                new MembershipsSection(
                    _.extend({}, baseSectionProps, {
                        sectionId: 4,
                        displayNameContentKey: 'HERO_SUB_MEMBERSHIPS',
                        template: 'memberships.html',
                        tabName: 'MEMBERSHIPS',
                        sectionSecurityKey: this.getSectionSecurityKey('MEMBERSHIPS', SecurityParts.KEY_PART_READ)
                    })
                ),

                new MemberBenefitTemplatesSection(
                    _.extend({}, baseSectionProps, {
                        sectionId: 5,
                        displayNameContentKey: 'HERO_SUB_MEMBERSHIP_BENEFIT_TEMPLATES',
                        template: 'memberBenefitTemplate.html',
                        tabName: 'MEMBERBENEFITTEMPLATES',
                        sectionSecurityKey: this.getSectionSecurityKey('MEMBERBENEFITTEMPLATES', SecurityParts.KEY_PART_READ)
                    })
                ),

                new ProductsSection(
                    _.extend({}, baseSectionProps, {
                        sectionId: 6,
                        displayNameContentKey: 'HEADER_PRODUCTS',
                        template: 'products.html',
                        tabName: 'PRODUCTS',
                        handlesOwnCrud: this.isPriceManagement,
                        sectionSecurityKey: this.getSectionSecurityKey('PRODUCTS', SecurityParts.KEY_PART_READ),
                        noun: Meevo.Model.NounEnum.PriceManagementProducts,
                        contextService: this.contextService,
                    })
                ),

                new ServicesSection(
                    _.extend({}, baseSectionProps, {
                        sectionId: 7,
                        displayNameContentKey: 'SERVICES',
                        template: 'services.html',
                        tabName: 'SERVICES',
                        handlesOwnCrud: this.isPriceManagement,
                        sectionSecurityKey: this.getSectionSecurityKey('SERVICES', SecurityParts.KEY_PART_READ),
                        noun: Meevo.Model.NounEnum.PriceManagementServices,
                        contextService: this.contextService,
                    })
                ),

                new SwapGroupsSection(
                    _.extend({}, baseSectionProps, {
                        sectionId: 8,
                        displayNameContentKey: 'HEADER_SWAP_UPGRADES',
                        template: 'swapGroups.html',
                        tabName: 'SWAPGROUP',
                        sectionSecurityKey: this.getSectionSecurityKey('SWAPGROUP', SecurityParts.KEY_PART_READ)
                    })
                ),

                new LocationsSection(
                    _.extend({}, baseSectionProps, {
                        sectionId: 9,
                        displayNameContentKey: 'LABEL_LOCATIONS',
                        template: 'locations.html',
                        tabName: 'LOCATIONS',
                        sectionSecurityKey: this.getSectionSecurityKey('LOCATIONS', SecurityParts.KEY_PART_READ)
                    })
                ),

                new ScheduledPriceChangeSection(
                    _.extend({}, baseSectionProps, {
                        sectionId: 10,
                        displayNameContentKey: 'LABEL_SCHEDULE_PRICE_CHANGE',
                        template: 'scheduledPriceChange.html',
                        tabName: 'SCHEDULEPRICECHANGE',
                        handlesOwnCrud: this.isPriceManagement,
                        sectionSecurityKey: this.getSectionSecurityKey('SCHEDULEPRICECHANGE', SecurityParts.KEY_PART_READ),
                        modalService: this.modalService,
                        noun: Meevo.Model.NounEnum.PriceManagementHistory, // TODO
                        contextService: this.contextService
                    })
                ),

                new HistorySection(
                    _.extend({}, baseSectionProps, {
                        sectionId: 11,
                        displayNameContentKey: 'LABEL_HISTORY',
                        template: 'history.html',
                        tabName: 'HISTORY',
                        handlesOwnCrud: this.isPriceManagement,
                        sectionSecurityKey: this.getSectionSecurityKey('HISTORY', SecurityParts.KEY_PART_READ),
                        noun: Meevo.Model.NounEnum.PriceManagementHistory
                    })
                )
            );

            this.sections = this.sections
                .filter(section => this.securityChecker.hasSecurityDenyOrGrant(section.sectionSecurityKey));
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
            this.businessTypeDetail = model.businessTypeDetail;
            if (model.availableAtLocations) {
                this.availableAtLocations = model.availableAtLocations;
            }
            if (model.totalLocations) {
                this.totalLocations = model.totalLocations;
            }
        }

        get showDelete() {
            return false;
        }

        get showCopy() {
            return false;
        }

        get showSave() {
            return this.showSaveLogic() && !this.selectedSection.isPreviewMassUpdate;
        }

        get showEdit() {
            return this.showEditLogic() && !(this.selectedSection instanceof LocationsSection);
        }

        get canEdit() {
            return this.verifySelectedSectionModel() &&
                this.isReadonly &&
                this.selectedSection.model.objectState !== Model.ObjectStateEnum.Deleted &&
                this.selectedSection.model.objectState !== Model.ObjectStateEnum.Merge;
        }

        public selectSection(item: SectionParamsMarketPrice<IPagerModel>): void {
            if (!this.isPriceManagement) {
                super.selectSection(item);
            } else {
                item.handlesOwnCrud = true;
                super.selectSection(item);
                this.selectedSection.handlesOwnCrud = false;

                if (this.selectedSection instanceof ProductsSection) {
                    this.selectedSection['manufacturer'] = undefined;
                    this.selectedSection['distributor'] = undefined;
                    this.selectedSection['productCategory'] = undefined;
                    this.selectedSection['productSubCategory'] = undefined;
                }
            }

            let baseKey = this.getSectionSecurityKey((<any>item).params.tabName);
            this.buildCrudSecurityKeysBase(baseKey);
        }

        fieldsReset(): void {
            this.selectedSection.isPreviewMassUpdate = false;
            if (this.selectedSection.massUpdateCriteria) {
                this.selectedSection.massUpdateCriteria.priceCategory = PriceCategoryEnum.Wholesale;
                this.selectedSection.massUpdateCriteria.amount = null;
                this.selectedSection.massUpdateCriteria.isPercent = false;
                this.selectedSection.massUpdateCriteria.round = null;
            }
        }

        postCancel(): void {
            // Copied from super postCancel()
            if (!this.isAdding) {
                this.updateCoBarData(this.selectedSection.model);
            } else {
                this.setMode(Model.MaintenanceFormState.Readonly);
            }
            if (this.verifyContextBusinessTypeDetail()) {
                this.selectedSection.model.businessTypeDetail = this.businessTypeDetail;
            }
            this.takeOwnership = false;
            if (this.verifySelectedSectionModel()) {
                if (Model.Guard.isSomething((<any>this.selectedSection.model).displayName) && !(this.selectedSection instanceof MemberBenefitTemplatesSection)) {
                    this.headerContent = (<any>this.selectedSection.model).displayName;
                }
            }
            if (Model.Guard.isSomething(this.closeCallback)) {
                this.closeCallback(null, true);
            }

            if (_.isFunction(this.selectedSection.postCancel)) {
                this.selectedSection.postCancel();
            }
            this.fieldsReset();
            this.forcePageLoading(this.selectedSection.massUpdateCriteria);
        }

        save(): angular.IPromise<any> {

            this.setBaseEndpoint();

            if (this.isAdding || this.isCopying || this.selectedSection instanceof MainSection) {
                return super.save();
            } else {
                let message = !this.isPriceManagement ? 'MESSAGE_PRICE_MANAGEMENT_SAVE_CHANGES' : 'MESSAGE_PRICE_MANAGEMENT_SAVE_CHANGES2';
                if (this.selectedSection.revertLocation) {
                    message = 'MESSAGE_PRICE_MANAGEMENT_SAVE_OVERWRITE';
                }
                if (this.isPriceManagement
                && !this.controller.isScheduleLocationContext
                && !this.controller.isSchedulePriceContext) {
                    const immediateChangesSections = [ProductsSection, ServicesSection];
                    if (immediateChangesSections.some(section => this.selectedSection instanceof section)) {
                        message = 'MESSAGE_PRICE_MANAGEMENT_SAVE_CHANGES_IMMEDIATE_CHANGES';
                    }
                }

                this.busyService.stop();
                return this.modalService.alert(message, Meevo.Components.Modal.ModalTranslationModes.Translate, false, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' })
                    .then((response: boolean) => {
                        if (response) {
                            return super.save();
                        }
                    })
            }
        }

        public isSchedulePriceShow(): boolean {
            return this.contextService.getVisualState() === Model.MaintenanceFormVisualState.CustomSchedulePrice;
        }

        setBaseEndpoint() {
            // Market Pricing
            if (!this.isPriceManagement) {
                this.baseEndpoint = this.appSettings.API_ENDPOINTS.marketPricing;
                return;
            }

            this.baseEndpoint = 'PriceManagement';

            if (this.selectedSection instanceof ServicesSection) {
                this.baseEndpoint = 'PriceManagement/Service';
                this.selectedSection.baseEndpoint = 'PriceManagement/Service';
            } else if (this.selectedSection instanceof ProductsSection) {
                this.baseEndpoint = 'PriceManagement/Product';
                this.selectedSection.baseEndpoint = 'PriceManagement/Product';
            }

            // Schedule Price Change
            if (this.isSchedulePriceShow()) {
                this.baseEndpoint = this.baseEndpoint + '/Price';
                this.selectedSection.baseEndpoint = this.selectedSection.baseEndpoint + '/Price';
            }
        }

        checkModelWarning(model: any): void {
            if (model.warning) {
                this.modalService.warning(model.warning, Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate);
            } else if (model.warningMessage) {
                this.modalService.warning(model.warningMessage, Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate);
            }
        }

        postAdd(model): void {
            if (model && model.id) {
                // selectedItemId is protected
                this.controller['selectedItemId'] = model.id;
            }
            super.postAdd(model);

            this.checkModelWarning(model);

            this.selectedSection.isPreviewMassUpdate = false;

            if (_.isFunction(this.selectedSection.postAdd)) {
                this.selectedSection.postAdd();
            }
        }

        postUpdate(model: any): void {
            if (!(this.selectedSection instanceof MemberBenefitTemplatesSection)) {
                let priceGroupId = this.selectedSection.filterCriteria.priceGroupId;

                this.selectedSection.filterCriteria = {
                    ...this.selectedSection.filterCriteria,
                    includeActive: true,
                    excludeScheduled: !!priceGroupId
                };

                super.postUpdate(model);
            }

            this.checkModelWarning(model);

            if(this.selectedSection instanceof ProductsSection) {
                let trackingItem = new Meevo.Model.TrackingItem(Meevo.Model.NounEnum.Product, Meevo.Model.VerbEnum.Updated, null);
                this.trackingService.saveTrackingInfo(trackingItem);
            }

            this.selectedSection.isPreviewMassUpdate = false;
        }

        // Pager
        // Virtual method to interact with paging functionality
        public forcePageLoading(criteria: any, itemsPerPage?: number): void {
        }

        public pagerApplyFilter() {
            if (this.selectedSection.showFilteredItems === false) {
                // when pager was rendered it send a request
                this.selectedSection.showFilteredItems = true;
            } else {
                this.forcePageLoading(this.selectedSection.filterCriteria);
            }

            this.usageTrackingLog(Meevo.Model.VerbEnum.SearchButtonClicked, null);
        }

        public massUpdatePreview() {

            this.selectedSection.massUpdateCriteria.amount = this.selectedSection.massUpdateCriteria.isPercent ? +this.selectedSection.amount * 100 : +this.selectedSection.amount;
            let criteria = this.selectedSection.massUpdateCriteria;
            //_.extend(criteria, this.selectedSection.filterCriteria);
            criteria.amount = this.selectedSection.massUpdateCriteria.amount;
            criteria.includeActive = this.selectedSection.massUpdateCriteria.includeActive;
            criteria.increase = this.selectedSection.massUpdateCriteria.increase;
            criteria.isPercent = this.selectedSection.massUpdateCriteria.isPercent;
            criteria.level = this.selectedSection.massUpdateCriteria.level;

            //Update security for applyMassUpdate button

            this.selectedSection.isPreviewMassUpdate = true;
            this.edit();
            this.forcePageLoading(criteria);
        }

        edit() {
            if (this.selectedSection instanceof MemberBenefitTemplatesSection) {
                if (!this.selectedSection.membership && !this.selectedSection.membershipBenefitTemplate) {
                    return;
                }
            }

            return super.edit();
        }

        // Backup for check changes
        public pagerOnPageLoaded() {
            this.selectedSection.takeBackup();
        }

        public pagerOnApplyFilter(): boolean {
            return this.isStartApplyFilter = true;
        }

        public pagerPreSelectPage(): ng.IPromise<any> {
            let returnPromise: ng.IPromise<any>;

            if (this.isStartApplyFilter) {
                this.isStartApplyFilter = false;

                let defer = this.$q.defer();
                defer.resolve(true);
                returnPromise = defer.promise;
            } else {
                returnPromise = this.checkSectionChangeData().then((resp) => {
                    if (resp) {
                        // Set default changes, extend for save link to original object
                        let originalEntity = this.selectedSection.originalEntity;
                        if (originalEntity) {
                            _.extend(this.selectedSection.model.pages, originalEntity.pages);
                        }
                        return true;
                    }
                });
            }

            return returnPromise;
        }

        checkSectionChangeData(): ng.IPromise<any> {
            let returnPromise: ng.IPromise<any>;

            // check section has changes
            if (this.isSectionChangedData()) {
                returnPromise = this.modalService.confirm('MESSAGE_CLOSE_UNSAVED', Meevo.Components.Modal.ModalTranslationModes.Translate);
            } else {
                let defer = this.$q.defer();
                defer.resolve(true);
                returnPromise = defer.promise;
            }

            return returnPromise;
        }

        isSectionChangedData(): boolean {
            let answer = false;
            let originalEntity = this.selectedSection.originalEntity;

            if (originalEntity) {
                answer = !angular.equals(this.selectedSection.model.pages, originalEntity.pages);
            }
            return answer;
        }

        // /Pager

        public scheduleLocationTransfer(): void {
            this.contextService.setVisualState(Model.MaintenanceFormVisualState.CustomScheduleLocation, this.selectedSection.model);
        }

        // Add "All" to typeAhead
        public addTypeaheadAllValue(response, request): void {
            let allValueItem = _.find(response, function (item: any) {
                return item.id == null;
            });

            if (!allValueItem && request.pageNumber === 0) {
                let itemAll;

                if (this.selectedSection instanceof HistorySection) {
                    itemAll = {
                        id: null,
                        storeName: 'All'
                    }
                } else {
                    itemAll = {
                        id: null,
                        displayName: 'All'
                    }
                }
                response.unshift(itemAll);
            }
        }

        public onDisplayPerPageChange() {
            this.forcePageLoading(this.selectedSection.filterCriteria, this.selectedSection.displayPerPage);
        }
    }
}
